// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1U43u","inner":"Form_inner__2b50r","range":"Form_range__3Ta56","name":"Form_name__3OwtH","actions":"Form_actions__2LaoI"};